export default __webpack_public_path__ + "static/media/Reviews-Bg.e48d36d3.jpg";